import { getTone } from "../utils/palette";

function getVariant(variant, tone) {
  if (variant === "secondary") {
    return tone
      ? "rounded-sm outline outline-[1px] -outline-offset-2 outline-[var(--tone)] px-4 py-2 text-[var(--tone)]"
      : "rounded-sm border px-4 py-2 text-black";
  }

  return tone
    ? "rounded-sm bg-[var(--tone)] px-4 py-2 text-white"
    : "rounded-sm bg-black px-4 py-2 text-white";
}

export default function Button({ children, type = "button", tone, variant = "primary", disabled = false, onClick, form, className = "" }) {
  return (
    <button type={type} disabled={disabled} onClick={onClick} form={form} className={`group inline-flex items-center justify-center disabled:pointer-events-none disabled:opacity-50 ${tone ? getTone(tone) : ""} ${getVariant(variant, tone)} ${className}`}>
      <span className="inline-block transition-transform group-hover:scale-105 group-disabled:scale-100">{children}</span>
    </button>
  );
}